import { render, staticRenderFns } from "./LaborCostList.vue?vue&type=template&id=4177cf62&"
import script from "./LaborCostList.vue?vue&type=script&lang=js&"
export * from "./LaborCostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports